const SURNAME_PARTICLES = new Set([
  "da", "de", "del", "della", "der", "di", "dos", "du", "la", "le",
  "van", "von", "zu", "zum", "zur",
]);

export function splitPersonName(value) {
  const parts = String(value || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { first_name: "", last_name: "" };
  if (parts.length === 1) return { first_name: parts[0], last_name: "" };
  let surnameStart = parts.length - 1;
  while (surnameStart > 1 && SURNAME_PARTICLES.has(parts[surnameStart - 1].toLocaleLowerCase())) {
    surnameStart -= 1;
  }
  return {
    first_name: parts.slice(0, surnameStart).join(" "),
    last_name: parts.slice(surnameStart).join(" "),
  };
}
